    document.addEventListener("DOMContentLoaded", function() {
  var thumbSwiper = new Swiper(".custom-featured-product .thumbSwiper", {
    spaceBetween: 25,
    slidesPerView: 5,
    watchSlidesProgress: true,
    loop: false, 
    navigation: {
      nextEl: ".custom-featured-product .thumbSwiper .swiper-button-next",
      prevEl: ".custom-featured-product .thumbSwiper .swiper-button-prev",
    },
    breakpoints: {
      769: { 
        direction: "horizontal",
      },
      481: { 
        direction: "horizontal",
      },
0: { 
          slidesPerView: 4,
           spaceBetween: 12,
      }
    }
  });

  var featuredSwiper = new Swiper(".custom-featured-product .featuredSwiper", {
    spaceBetween: 1,
    slidesPerView: 1,
    navigation: {
      nextEl: ".custom-featured-product .featuredSwiper .swiper-button-next",
      prevEl: ".custom-featured-product .featuredSwiper .swiper-button-prev",
    },
    thumbs: {
      swiper: thumbSwiper,
    },
  });
});

$(document).ready(function() {
  $(".custom-featured-product .desc_wrapper").each(function() {
    var $wrapper = $(this);
    var $desc2 = $wrapper.find(".desc2");
     var $desc1 = $wrapper.find(".desc1");
    var $readMore = $wrapper.find(".read_more");
    var $readLess = $wrapper.find(".read_less");

    $readMore.on("click", function() {
      $desc2.stop(true, true).slideDown(600);  // show extended desc
      $readMore.hide();                        // hide "Read More"
      $readLess.show(); 
      $desc1.hide();// show "Read Less"
    });

    $readLess.on("click", function() {
      $desc2.stop(true, true).slideUp(600);    // hide extended desc
      $readLess.hide();                         // hide "Read Less"
      $readMore.show(); 
        $desc1.show();                        // show "Read More"
    });
  });
});



$(document).ready(function() {
    var activeItem = $(".custom-featured-product .product.grid .product__info-wrapper .custom_bundles .custom_item.active");

    if(activeItem.length) {
        var index = activeItem.data("index"); 
  

        $(".product-form .product-variant-quanitty").val(index);
    }
    $(document).on("click", ".custom-featured-product .product.grid .product__info-wrapper .custom_bundles .custom_item", function() {
        $(this).siblings(".custom_item").removeClass("active");
        $(this).addClass("active");
        var index = $(this).data("index"); 
        $(".product-form .product-variant-quanitty").val(index);

    });


});




// main product js
   document.addEventListener("DOMContentLoaded", function() {
  var thumbSwiper = new Swiper(".main_product .thumbSwiper", {
    spaceBetween: 25,
    slidesPerView: 5,
    watchSlidesProgress: true,
    loop: false, 
    navigation: {
      nextEl: ".main_product .thumbSwiper .swiper-button-next",
      prevEl: ".main_product .thumbSwiper .swiper-button-prev",
    },
    breakpoints: {
      769: { 
        direction: "horizontal",
      },
      481: { 
        direction: "horizontal",
      },
0: { 
          slidesPerView: 4,
           spaceBetween: 12,
      }
    }
  });

  var featuredSwiper = new Swiper(".main_product .featuredSwiper", {
    spaceBetween: 1,
    slidesPerView: 1,
    navigation: {
      nextEl: ".main_product .featuredSwiper .swiper-button-next",
      prevEl: ".main_product .featuredSwiper .swiper-button-prev",
    },
    thumbs: {
      swiper: thumbSwiper,
    },
  });
});


$(document).ready(function() {
  $(".main_product .desc_wrapper").each(function() {
    var $wrapper = $(this);
    var $desc2 = $wrapper.find(".desc2");
     var $desc1 = $wrapper.find(".desc1");
    var $readMore = $wrapper.find(".read_more");
    var $readLess = $wrapper.find(".read_less");

    $readMore.on("click", function() {
      $desc2.stop(true, true).slideDown(600);  // show extended desc
      $readMore.hide();                        // hide "Read More"
      $readLess.show(); 
      $desc1.hide();// show "Read Less"
    });

    $readLess.on("click", function() {
      $desc2.stop(true, true).slideUp(600);    // hide extended desc
      $readLess.hide();                         // hide "Read Less"
      $readMore.show(); 
        $desc1.show();                        // show "Read More"
    });
  });
});

$(document).ready(function() {
    var activeItem = $(".main_product .product.grid .product__info-wrapper .custom_bundles .custom_item.active");

    if(activeItem.length) {
        var index = activeItem.data("index"); 
  

        $(".product-form .product-variant-quanitty").val(index);
    }
    $(document).on("click", ".main_product .product.grid .product__info-wrapper .custom_bundles .custom_item", function() {
        $(this).siblings(".custom_item").removeClass("active");
        $(this).addClass("active");
        var index = $(this).data("index"); 
        $(".product-form .product-variant-quanitty").val(index);
        withLoop();
    });
      function withLoop() {
      const priceText = $('.custom_bundles .custom_item.active .badge_price_wrap .price')
        .text()
        .trim();
      console.log('priceText:', priceText);
    
      $('.loop-widget-purchase-option-onetime .loop-widget-purchase-option-price')
        .text(priceText);
    
      const loopPriceNum = parseFloat(priceText.replace(/[^0-9.]/g, '')) || 0;
      console.log('loopPriceNum:', loopPriceNum);
    
      const loopSavePriceNum = loopPriceNum * 0.9;
      const loopSavePrice = '$' + loopSavePriceNum.toFixed(2);
      console.log('loopSavePrice:', loopSavePrice);
    
      $('.main_product .loop-widget-purchase-option[data-loop-widget-selling-plan-group] .loop-widget-purchase-option-price')
        .text(loopSavePrice);
    
      $('.main_product .loop-widget-purchase-option[data-loop-widget-selling-plan-group] .loop-widget-purchase-option-compare-at-price')
        .text(priceText);
    }
});


//  CSUTOM UPSELL PDP
document.addEventListener('DOMContentLoaded', function() {
  new Swiper('.custom-upsell-section .custom-upsell-slider', {
    slidesPerView: 1.2,
    spaceBetween: 15,
    loop: true,
     pagination: {
      el: ".custom-upsell-section .swiper-progressbar",
      type: "progressbar",
    },
    breakpoints: {
      768: { slidesPerView: 1.5 },
      1024: { slidesPerView: 1.5 },
    },
  });
});


$(document).on('click', 'button.upsell-add-btn', function(e) {
    e.preventDefault();

    var $button = $(this);
    var $product = $button.closest('.upsell-product');
    var id_data = $product.find('input[name="id"]').val();

    // Show loader
    $button.find('.btn-text').hide();
    $button.find('.btn-loader').show();
    $button.prop('disabled', true); // prevent multiple clicks

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id_data, quantity: 1 })
    })
    .then(response => response.json())
    .then(data => {
        console.log('Variant added to cart:', data);

        fetch('/?sections=cart-drawer')
          .then(res => res.json())
          .then(sectionData => {
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = sectionData['cart-drawer'];
              const newCartDrawer = tempDiv.querySelector('cart-drawer');
refreshCartBubbleOnly();
              if (newCartDrawer) {
                  const existingCartDrawer = document.querySelector('cart-drawer');
                  if (existingCartDrawer) existingCartDrawer.replaceWith(newCartDrawer);

                  // Open cart drawer
                  newCartDrawer.classList.add('animate', 'active');
                  document.body.classList.add('cart-drawer-open');
              }
          });
    })
    .catch(error => {
        console.error('Error adding variant to cart:', error);
        alert('Sorry, something went wrong.');
    })
    .finally(() => {
        // Hide loader and re-enable button
        $button.find('.btn-loader').hide();
        $button.find('.btn-text').show();
        $button.prop('disabled', false);
    });
});


function refreshCartBubbleOnly() {
  fetch("/cart.js")
    .then(res => res.json())
    .then(cart => {
      const bubble = document.querySelector("#cart-icon-bubble");
      const bubbleCount = bubble?.querySelector(".cart-count-bubble > span[aria-hidden='true']");
      const visuallyHidden = bubble?.querySelector(".cart-count-bubble .visually-hidden");

      if (bubble && bubbleCount && visuallyHidden) {
        const totalItems = cart.item_count;

        // Update visible number
        bubbleCount.textContent = totalItems;

        // Update screen-reader text
        visuallyHidden.textContent = `Total items in cart: ${totalItems}`;

        // Optional styling
        bubble.classList.toggle("has-items", totalItems > 0);
      }
    })
    .catch(err => console.error("Error refreshing cart bubble:", err));
}


